document.addEventListener('DOMContentLoaded', () => {
  const extensionOffset = -3
  const localhost = window.location.hostname

  for (let i = 0; i < document.links.length; ++i) {
    const linkEl = document.links[i]
    const extension = linkEl.href.substr(extensionOffset).toLowerCase()
    const isExternalized = linkEl.classList.contains('js-externalized')
    const externalDisabled = linkEl.classList.contains('js-external-disabled') || linkEl.hasAttribute('data-bs-toggle')

    // use js-external-disabled class to disable this behavior entirely
    if (!externalDisabled) {
      if (linkEl.hostname !== localhost && (linkEl.protocol === 'http:' || linkEl.protocol === 'https:') || extension === 'pdf' || isExternalized) {
        linkEl.addEventListener('click', (e) => {
          const eventGa = window?.Nematis?.forms2GA
          const noClick = linkEl.classList.contains('js-no-click')
          const noExternal = linkEl.classList.contains('js-no-external')
          let triggerGa = !(noClick || noExternal)
          if (!linkEl.hasAttribute('target')) {
            e.preventDefault()

            if (!noClick) {
              if (noExternal) {
                window.location.href = linkEl.href
              } else {
                window.open(linkEl.href)
              }
            }
          } else {
            triggerGa = linkEl.target === '_blank'
          }

          if (triggerGa && typeof eventGa !== 'undefined') {
            eventGa.triggerGA('External link', 'external_click', linkEl.href)
          }
        })
      }
    }
  }
})
